// export const changeLanguage = (lang) => {
//   const selectField = document.querySelector(".goog-te-combo");

//   if (!selectField) {
//     console.warn("Google translate dropdown not ready");
//     setTimeout(() => changeLanguage(lang), 500);
//     return;
//   }

//   selectField.value = lang;
//   selectField.dispatchEvent(new Event("change"));
// };


export const changeLanguage = (lang) => {
  const tryChange = () => {
    const select = document.querySelector(".goog-te-combo");

    if (!select) {
      setTimeout(tryChange, 500);
      return;
    }

    // if already same language → force refresh
    if (select.value === lang) {
      select.value = "en"; // temporary switch (or any default)
      select.dispatchEvent(new Event("change", { bubbles: true }));
    }

    setTimeout(() => {
      select.value = lang;

      // Trigger REAL native events
      select.dispatchEvent(new Event("change", { bubbles: true }));
      select.dispatchEvent(new Event("input", { bubbles: true }));

      // extra fallback (important for Google)
      const event = document.createEvent("HTMLEvents");
      event.initEvent("change", true, true);
      select.dispatchEvent(event);
    }, 150);
  };

  tryChange();
};